export default __webpack_public_path__ + "static/media/LZ_ZimaKrov.9a69292f.svg";